import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { HardHat, Home, List, FileText, User } from "lucide-react";

const NavItem = ({ to, label, icon: Icon, testid }) => (
  <NavLink
    to={to}
    data-testid={testid}
    className={({ isActive }) =>
      `flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
        isActive
          ? "bg-blue-600 text-white shadow-sm"
          : "text-gray-700 hover:bg-gray-100"
      }`
    }
  >
    <Icon className="w-4 h-4" />
    <span>{label}</span>
  </NavLink>
);

export default function InstallerLayout({ children }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* Top bar */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-20">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
          <button
            type="button"
            onClick={() => navigate("/")}
            className="flex items-center gap-3"
            data-testid="installer-brand"
          >
            <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-2 rounded-lg text-white">
              <HardHat className="w-5 h-5" />
            </div>
            <div className="text-left">
              <div className="text-lg font-bold leading-tight">
                RoofBidder • Installer
              </div>
              <div className="text-xs text-gray-500">Bid. Win. Build.</div>
            </div>
          </button>

          {/* Primary navigation */}
          <nav
            className="hidden md:flex items-center gap-2"
            aria-label="Installer navigation"
          >
            <NavItem
              to="/installer"
              label="Dashboard"
              icon={Home}
              testid="nav-installer-dashboard"
            />
            <NavItem
              to="/installer/jobs"
              label="Browse Jobs"
              icon={List}
              testid="nav-installer-jobs"
            />
            <NavItem
              to="/installer/bids"
              label="My Bids"
              icon={FileText}
              testid="nav-installer-bids"
            />
            <NavItem
              to="/installer/profile"
              label="Profile"
              icon={User}
              testid="nav-installer-profile"
            />
          </nav>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1">
        <div className="max-w-7xl mx-auto px-32 py-6">{children}</div>
      </main>
    </div>
  );
}
